import type { TWidget } from '../../../utility/types/dataProvider';

/**
 * Custom hook that provides utility functions for dashboard widgets.
 * 
 * @returns Object containing helper functions for widget operations
 */
export const useDashboardWidgetHelpers = () => {
  /**
   * Determines if widget actions (export, expand, etc.) should be hidden.
   * RSS widgets are handled separately in Widget.tsx.
   * 
   * @param widgetModule - The widget module identifier
   * @returns True if widget actions should be hidden
   */
  const hideWidgetActions = ({ widgetModule }: { widgetModule: string }): boolean => {
    const nonExportableWidgets = ['help', 'status'];
    return nonExportableWidgets.includes(widgetModule);
  };

  /**
   * Gets the app value for a widget, accounting for custom widgets.
   * 
   * @param widget - The widget object
   * @returns The app identifier for the widget
   */
  const getWidgetAppValue = (widget: TWidget): string => {
    return widget?.module?.app || widget?.app;
  };

  return {
    hideWidgetActions,
    getWidgetAppValue,
  };
};

// Export individual functions for backward compatibility and non-hook usage
export const hideWidgetActions = ({ widgetModule }: { widgetModule: string }): boolean => {
  const nonExportableWidgets = ['help', 'status'];
  return nonExportableWidgets.includes(widgetModule);
};

export const getWidgetAppValue = (widget: TWidget): string => {
  return widget?.module?.app || widget?.app;
};
